// ** React Imports
import {
  Fragment, useEffect, useState, useRef
  // , useState, useEffect 
} from "react"
// ** Custom Components
import NavbarUser from "./NavbarUser"
import NavbarDropdown from "./NavbarDropdown"
// ** Third Party Components
import { Menu, X } from "react-feather"
import { useNavigate, useLocation } from "react-router-dom"
// ** Reactstrap Imports
import { NavItem, NavLink, Button, Input, UncontrolledTooltip, Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from "reactstrap"
import Select, { components } from 'react-select'
import { DefaultConfig } from '../../../../settings/config'
// import { isUserLoggedIn } from "@utils"
import { handleMenuCollapsed } from "../../../../redux/layout"
// ** Configs
import themeConfig from "../../../../configs/themeConfig"
// ** Store & Actions
import { useDispatch, useSelector } from "react-redux"
import GlobalVariable from "../../../../settings/global"
import CustomValueContainer from '../../../../views/Components/Select'
import { isUserLoggedIn } from '../../../../@core/auth/utils'
import LoadingOpaqueSpinner from '../../../../components/spinner/Loading-opaque-spinner'
import { GetAgentDetails, getCompanyValue, ImpersonateUser, handleCusEmailChange, loadingOpaqueSpinnerStatus, handleEmptyUserAgents, displayMenu, getRefreshToken } from "../../../../views/redux/store"
//import { Row, , Button, UncontrolledTooltip, TabContent, TabPane, Nav, NavItem, NavLink, Badge } from 'reactstrap'
// import {  } from "../../../../views/redux/store"
import useSessionTimeout from './useSessionTimeout'

const headerText = GlobalVariable.headerText
const ThemeNavbar = (props) => {
  const dispatch = useDispatch()
  const location = useLocation()
  const loggedinUserDetails = isUserLoggedIn() && JSON.parse(isUserLoggedIn())
  const [salesforce, setSalesforce] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const selectRef = useRef(null)
  const selectRefs = useRef(null)
  const [isMenuOpen, setMenuOpen] = useState(false)
  const stores = useSelector((state) => state.commonreducerSlice)
  const selectStyles = DefaultConfig().selectStyles
  const [addCompanyOption, setAddCompanyOption] = useState(false)
  const [agentObj, setCompanyObj] = useState(localStorage.getItem('agentObj') ? JSON.parse(localStorage.getItem('agentObj')) : '')
  const [companyData, setCompanyData] = useState(stores.allCompanies)
  const [customerEmail, setCustomerEmail] = useState(localStorage.getItem('customerEmail') ? localStorage.getItem('customerEmail') : '')
  const [errorMessage, setErrorMessage] = useState("")
  const [emailDisable, setEmailDisable] = useState(false)
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  //const [displayMenu, setDisplayMenu] = useState(false)
  const handleWindowWidth = () => {
    setWindowWidth(window.innerWidth)
  }
  useEffect(() => {
    if (window !== undefined) {
      window.addEventListener("resize", handleWindowWidth)
    }
  }, [windowWidth])

  function formatTime(seconds) {
    const hours = Math.floor(seconds / 3600)
    const minutes = Math.floor((seconds % 3600) / 60)
    const secs = Math.floor(seconds % 60)
    return { hours, minutes, seconds: secs }
  }
  const [sPopup, setSPopUp] = useState(false)
  const [tokenShow, setTokenShow] = useState(false)
  const [spinnerUStatus, setSpinnerStatus] = useState(true)

  async function refreshToken() {
    await dispatch(getRefreshToken())
    setSpinnerStatus(true)
    setSPopUp(false)
    setTokenShow(true)
    setTimeout(() => {
      setTokenShow(false)
    }, 5000)
  }

  const { showPopup, timeLeft } = useSessionTimeout(localStorage.getItem('token'), refreshToken, sPopup, tokenShow)
  const formattedTime = formatTime(timeLeft || 0)

  const updateYes = async () => {
    setSpinnerStatus(false)
    refreshToken()
  }

  useEffect(() => {
    setSPopUp(showPopup)
  }, [showPopup])
  // ** Props
  const { skin, setSkin, menuCollapsed } = props
  const navigate = useNavigate()


  const NoOptionsMessage = (props) => {
    return (
      <components.NoOptionsMessage {...props}>
        {addCompanyOption ? (
          <Fragment>
            No Options
          </Fragment>
        ) : (
          <div>Enter min 3 characters.</div>
        )}
      </components.NoOptionsMessage>
    )
  }
  const handleMenuClose = () => {
    setMenuOpen(false)
  }
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (selectRef.current && !selectRef.current.contains(e.target)) {
        handleMenuClose()
      }
    }

    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    } else {
      document.removeEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isMenuOpen])
  const navigateMainPage = () => {
    sessionStorage.setItem('pageTransition', 'LR')
    navigate('/dashboard')
  }
  const trueBool = true
  const handleInputChange = (inputValue, action) => {
    if (action.action !== "input-blur" && action.action !== "menu-close") {
      if (inputValue.length > 0) {

        setEmailDisable(true)
      } else {
        setEmailDisable(false)
      }
      setSalesforce(inputValue)
    }
  }

  useEffect(() => {
    if (salesforce.length > 2) {
      setIsLoading(true)
      const timer = setTimeout(() => {
        const searchOptions = async () => {
          if (salesforce) {
            const responseData = await dispatch(GetAgentDetails(salesforce))
            const companyData = responseData.payload
            if (companyData) {
              const sfCompanys = []
              if (companyData.length > 0) {
                companyData.forEach((item) => {
                  if (item.customerNumber) {
                    sfCompanys.push({ value: item.customerNumber, label: `${item.customerName} ${item.customerNumber !== null ? `(${item.customerNumber})` : ''}`, name: item.customerName, agentId: item.customerNumber, classId: item.customerClassId })
                  }
                })
              } else {
                setAddCompanyOption(true)
              }
              setCompanyData(sfCompanys)
              setIsLoading(false)
            }
          }
        }
        if (salesforce) {
          setIsLoading(true)
          setAddCompanyOption(false)
          searchOptions()
        } else {
          setIsLoading(false)
          setCompanyData([])
        }
      }, 500)
      return () => clearTimeout(timer)
    } else {
      setIsLoading(false)
      setCompanyData([])
      setAddCompanyOption(false)
    }
  }, [salesforce])

  useEffect(() => {
    if (stores.customerEmail) {
      dispatch(loadingOpaqueSpinnerStatus(true))
      dispatch(ImpersonateUser(stores.customerEmail))
    } else {
      dispatch(handleEmptyUserAgents([]))
    }
  }, [stores.customerEmail])
  async function displayFunction() {
    await dispatch(displayMenu(!stores?.displayMenuBool))
  }
  const handleEmailChange = async (email) => {
    //  console.log(email, 'test')
    dispatch(handleCusEmailChange(email))
  }
  function handleKeyPress(e) {
    if (e.key === 'Enter') {
      const enteredEmail = e.target.value.trim()
      if (enteredEmail.length > 0) {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (!emailPattern.test(enteredEmail)) {
          setErrorMessage('Enter a valid email address')
        } else {
          handleEmailChange(enteredEmail)
        }
      }
    }
  }
  function imputfields() {
    return (
      <div className="parent_nav d-none">
        {loggedinUserDetails.isEmployee ? (<div className="d-flex parentContainer">
          <div ref={selectRef} className='search-by-agent' >
            <Select
              ref={selectRefs}
              isClearable
              onChange={(val) => {
                setCompanyObj(val)
                localStorage.setItem('agentObj', JSON.stringify(val))
                async function fetchData() {
                  await dispatch(getCompanyValue(val))
                }
                fetchData()
              }}
              inputValue={salesforce}
              classNamePrefix="select"
              options={companyData}
              value={agentObj}
              className='react-select custom-value-container '
              components={{ NoOptionsMessage, ValueContainer: CustomValueContainer }}
              styles={selectStyles}
              onInputChange={handleInputChange}
              isLoading={isLoading}
              loadingMessage={() => 'Loading...'}
              isDisabled={customerEmail.length > 0}
              placeholder={emailDisable ? "" : "Search by Agent Id or Name"}
              id='showAgentTooltip'
            />
          </div>
          {agentObj && <UncontrolledTooltip placement='right' target='showAgentTooltip'>
            {agentObj.label}
          </UncontrolledTooltip>}
          <div className="mx-1 mt-1">or</div>
          <div>
            <div className='input-wrapper userId_width'>
              <Input id='userID'
                type="text"
                disabled={agentObj?.label || emailDisable}
                placeholder='User Email'
                value={customerEmail}
                className={errorMessage.length > 0 && 'inputErrorMessage'}
                onChange={(e) => {
                  setCustomerEmail(e.target.value)
                  if (customerEmail !== e.target.value) {
                    setErrorMessage("")
                  }
                }}
                autoComplete="off"
                onKeyPress={(e) => handleKeyPress(e)}
                onBlur={(e) => {
                  const enteredEmail = e.target.value.trim()
                  if (enteredEmail.length > 0) {
                    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
                    if (!emailPattern.test(enteredEmail)) {
                      setErrorMessage('Enter a valid email address')
                    } else {
                      handleEmailChange(enteredEmail)
                    }
                  }
                }}
                // onKeyDown={handleKeyDown}

                onFocus={() => { setErrorMessage("") }}
              />
              {customerEmail &&
                <div onClick={() => {
                  setCustomerEmail('')
                  handleEmailChange('')
                }} color="primary" className='clear-icon'>
                  <X size={16} strokeWidth={3} />
                </div>
              }

              {errorMessage.length > 0 && <div className="errorMessage">{errorMessage}</div>}
            </div>
          </div>

        </div>
        ) : (
          <>
          </>
        )
        }
        {stores.loadingOpaqueSpinner &&
          <LoadingOpaqueSpinner />
        }
      </div>)
  }
  useEffect(() => {
    if (menuCollapsed) {
      document.documentElement.style.setProperty('--padding', '0 7rem 0 0.5rem')
    } else {
      document.documentElement.style.setProperty('--padding', '0 13rem 0 0.5rem')
    }
  }, [menuCollapsed])

  return (
    <Fragment>

      <div className="bookmark-wrapper">
        <ul className="navbar-nav add_dropdowndisplay">
          <NavItem className="mobile-menu">
            <NavLink
              className={menuCollapsed ? "nav-menu-main menu-toggle  hidden-xs is-active" : "nav-menu-main menu-toggle hidden-xs is-active p-0"}
              onClick={() => {
                // setMenuVisibility(true)
                dispatch(handleMenuCollapsed(menuCollapsed ? false : trueBool))
              }}
            >
              <Button
                className="btn-icon btn_Action btn_Action_Icon"
                color="secondary"
                style={{ top: headerText ? '22px' : '10px', display: windowWidth <= 1200 ? "unset" : "none" }}
                onClick={() => { displayFunction() }}
              >
                <Menu className="ficon" size={24} />
              </Button>
            </NavLink>
          </NavItem>
          <li className="nav-item">
            <div className="d-flex">
              <div className={`Client_lable `}>Contact Management</div>
              {/* <span className="env_class"> | </span> */}
              {/* {!loggedinUserDetails.isEmployee && <span className="emp_email">You are logged in with {loggedinUserDetails.email}</span>} */}
            </div>
          </li>
          <li className="nav-item add_dropdown">
            {imputfields()}
            <div>
            </div>
          </li>
        </ul>
        <div className="navbar-header d-none" style={{ marginLeft: menuCollapsed ? '0px' : '56px' }}>
          <ul className="nav navbar-nav flex-row">
            <li className="nav-item me-auto">
              <NavLink
                onClick={() => { }
                  // navigateMainPage()
                }
                className="navbar-brand"
              >
                <span className="brand-logo">
                  <img src={themeConfig.app.appLogoImage} alt="logo" className="sea_logo_header" />
                </span>
              </NavLink>
            </li>
          </ul>
        </div>
        {/* <div className="navbar-header" style={{ marginLeft: '0px' }}>
            <ul className="nav navbar-nav flex-row">
              
            </ul>
          </div> */}
        {location.pathname === '/dashboard' &&
          <ul className="navbar-nav d-none">
            <NavbarDropdown />
          </ul>
        }
      </div>
      <NavbarUser skin={skin} setSkin={setSkin} />
      <div className="Down_inputfields">
        {imputfields()}
      </div>

      {sPopup &&
        <div className='vertically-centered-modal'>
          <Modal scrollable className='modal-dialog-centered' isOpen={sPopup}>
            <ModalHeader>Session Time Out</ModalHeader>
            <ModalBody>
              <div className="p-1">
                <div className="popup">Your session will expire soon due to inactivity!</div>
                <p> Session expires in: <span className="text-danger">{formattedTime.minutes}m {formattedTime.seconds}s</span>. Do you want continue session? </p>
              </div>
            </ModalBody>
            <ModalFooter>
              <div className='model_popup_submit_btn'>
                {/* <Button color='secondary' onClick={() => updateNo()} className='me-1 reset_button_view'> No </Button> */}
                {spinnerUStatus ? (
                  <Button color='secondary' onClick={() => updateYes()} className='create_submit_btn'> Yes </Button>
                ) : (
                  <Button className='me-1' color='secondary' type='submit' disabled={!spinnerUStatus}>
                    <Spinner size='sm' />
                    <span className='mx-50'>Loading...</span>
                  </Button>
                )}
              </div>
            </ModalFooter>
          </Modal>
        </div>
      }
    </Fragment>
  )
}

export default ThemeNavbar
